import { LitElement, html, css } from 'lit';

class MovingHandle extends LitElement {
    static styles = css`
    :host {
        position: fixed;
        z-index: 1000;
        touch-action: none;
    }
    .handle {
        width: 25px;
        height: 25px;
        border: 1px solid rgb(185, 185, 185);
        border-radius: 19%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        background-color: rgb(247, 247, 247);
        box-shadow: rgba(0, 0, 0, 0.5) 0px 2px 5px;
        cursor: move;
        touch-action: none;
    }
    
    hr {
        width: 54%;
        margin: 1px;
        border-right: none;
        border-bottom: none;
        border-left: none;
        border-image: initial;
        border-top: 2px solid rgb(193, 193, 193);
    }
  `;

    constructor() {
        super();
    }

    render() {
        return html`
      <div class="handle">
        <slot></slot>
        <hr>
        <hr>
        <hr>
      </div>
    `;
    }
}

customElements.define('moving-handle', MovingHandle);
